class Video {
    config = {
        players: [],  // Store both YouTube and Vimeo players
        lib: {
            youtube: 'https://www.youtube.com/iframe_api',
            vimeo: 'https://player.vimeo.com/api/player.js'
        }
    }

    constructor() {
        this.init();
    }

    init() {
        let _t = this;

        $('.block-video').each((i, e) => _t.buildVideo(i, $(e)));
    }

    buildVideo(number, video) {
        let _t = this;

        let $video  = $(video);
        let $iframe = $video.find('iframe').attr('id', 'video-iframe-' + number);
        let id      = $iframe.attr('id');
        let src     = $iframe.attr('src');

        // Check for YouTube or Vimeo in the src and adjust accordingly
        if (src.includes('youtube')) {
            _t.loadYouTube(id);
        } else if (src.includes('vimeo')) {
            _t.loadVimeo(id);
        }
    }

    loadScript(lib) {
        return new Promise((resolve, reject) => {
            if (!document.querySelector(`script[src="${lib}"]`)) {
                let script = document.createElement('script');
                script.src = lib;
                script.onload = resolve;
                script.onerror = reject;
                document.head.appendChild(script);
            } else {
                resolve(); // Script already loaded
            }
        });
    }

    loadYouTube(id) {
        let _t = this;

        this.loadScript(_t.config.lib.youtube).then(() => {
            if (typeof YT === "undefined" || typeof YT.Player === "undefined") {
                window.onYouTubePlayerAPIReady = function () {
                    _t.buildYouTubePlayer(id);
                };
            } else {
                _t.buildYouTubePlayer(id);
            }
        }).catch(() => {
            console.error("Failed to load YouTube API.");
        });
    }

    buildYouTubePlayer(id) {
        let _t = this;
        let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent); // Detect mobile

        // Get the existing iframe element
        let $iframe = $('#' + id);
        let src = $iframe.attr('src'); // Get the src attribute from the iframe

        // Extract videoId from YouTube URL
        let videoId = _t.extractYouTubeVideoId(src);

        // Get the parent container where the new player will be inserted
        let $videoContainer = $('#' + id).parents('.block-video').find('.video');

        // Use the same ID for the new YouTube player
        $videoContainer.append('<div id="' + id + '"></div>');

        // Remove the existing iframe
        $iframe.remove();

        // Create the new YouTube player using the extracted videoId
        let player = new YT.Player(id, {
            videoId: videoId, // Use the extracted video ID
            playerVars: {
                'enablejson': 1,
                'playsinline': 1, // Play inline on iOS
                'autoplay': 0, // Disable autoplay on mobile
                'rel': 0, // Disable related videos
                'mute': (isMobile) ? 1 : 0 // Mute the video from the start
            },
            events: {
                'onReady': function () {
                    if (!isMobile) {
                        player.mute(); // Mute on desktop immediately
                    }

                    // Push player into the config for future use
                    _t.config.players.push({
                        id: id,
                        type: 'youtube',
                        player: player
                    });

                    _t.bindEventHandlers(id);
                }
            }
        });
    }

    extractYouTubeVideoId(src) {
        let videoId = null;

        // Check for different types of YouTube URLs and extract the videoId
        let regex = /(?:youtube\.com\/(?:embed\/|watch\?v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
        let match = src.match(regex);

        if (match && match[1]) {
            videoId = match[1];
        }

        return videoId;
    }


    loadVimeo(id) {
        let _t = this;

        this.loadScript(_t.config.lib.vimeo).then(() => {
            _t.buildVimeoPlayer(id);
        }).catch(() => {
            console.error("Failed to load Vimeo API.");
        });
    }

    buildVimeoPlayer(id) {
        let _t = this;

        let player = new Vimeo.Player(id);

        player.on('loaded', function () {
            _t.config.players.push({
                id: id,
                type: 'vimeo',
                player: player
            });

            _t.bindEventHandlers(id);
        });
    }

    bindEventHandlers(id) {
        let _t = this;
        let $video      = $('#' + id).parents('.block-video');
        let $image      = $video.find('.image');
        let $content    = $video.find('.content');
        let $link       = $content.find('.el-link');

        $link.removeAttr('href');

        $link.off('click').on('click', function (e) {
            e.preventDefault();

            $image.hide();
            $content.hide();

            let playerObj = _t.config.players.find(p => p.id === id);

            if (playerObj) {
                playerObj.player.mute();

                // Wait for a slight delay to ensure muting happens first
                setTimeout(() => {
                    if (playerObj.type === 'youtube') {
                        playerObj.player.playVideo(); // Play the YouTube video after user interaction
                    } else if (playerObj.type === 'vimeo') {
                        playerObj.player.play(); // Play the Vimeo video
                    }
                }, 100); // Slight delay to ensure mute is applied before playing
            }
        });
    }
}

$(() => {
    if ($('.block-video').length) new Video()
})
